/**
 * Best-effort removal of first-party analytics cookies on consent withdrawal.
 *
 * Shared by GA (`_ga`, `_ga_*`) and Clarity (`_clck`, `_clsk`). Tries the exact
 * host, the registrable-domain fallback (".example.com") and no domain at all,
 * because the trackers set their cookies on different variants.
 */
export function clearCookiesMatching(pattern: RegExp): void {
  if (typeof document === 'undefined') return
  const host = window.location.hostname
  const domains = [host, `.${host.split('.').slice(-2).join('.')}`]
  for (const raw of document.cookie.split(';')) {
    const name = raw.split('=')[0]?.trim()
    if (!name || !pattern.test(name)) continue
    for (const domain of domains) {
      // biome-ignore lint/suspicious/noDocumentCookie: der Widerruf muss die Tracker-Cookies WIRKLICH loeschen; die Cookie-Store-API ist asynchron und trifft die Domain-Varianten nicht.
      document.cookie = `${name}=; Max-Age=0; path=/; domain=${domain}`
    }
    // biome-ignore lint/suspicious/noDocumentCookie: dito, ohne Domain — fuer Cookies, die ohne gesetzt wurden.
    document.cookie = `${name}=; Max-Age=0; path=/`
  }
}
